module.exports = __webpack_public_path__ + "img/jx.d0289dc0.png";